import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../core';
import { PessoaEnderecoTipo } from '../../pessoa/endereco';

@Injectable({
    providedIn: 'root'
})
export class EstadoSearchesHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/estado`;
    }

    /** Obtem o percentual da alíquota do ICMS do estado da pessoa e tipo de endereço dela informados */
    getPercAliquotaIcmsPessoa(idPessoa: number, tipoEndereco: PessoaEnderecoTipo): Observable<number> {
        // Params
        let params = new HttpParams();
        // Pessoa
        if (idPessoa) {
            params = params.append('idPessoa', idPessoa.toString());
        }
        // Tipo Endereço
        if (tipoEndereco) {
            params = params.append('tipoEndereco', tipoEndereco.id.toString());
        }

        return this.customHttp.get<number>(`${this.pathApi}/0/aliquotaicms/pessoa`, {params});
    }
}
